import React from "react";
import './text.css';

const Zaostrov = () => {
    return (
        <div align={'start'} className="text1">
            <h2>«Заостровское дело»</h2>
            
            <p class="has-text-align-right"><i>С кем-то из гостей Заостровья мы обсуждали,
                как сказочно звучит это название – Заостровье. Но сказочно иначе, чем Град
                Китеж: не как ушедшее на дно прошлое, но как неведомое будущее</i></p>
            

            
            <p class="has-text-align-right"><i>Ольга Седакова</i></p>
            

            
            <p>Село
                Заостровье, объединяющее до 25 деревень между Архангельском и Северодвинском –
                место древнее, плодородное и богатое. Два храма – один деревянный, памятник
                XVII века (в нем не служат), другой каменный, начала XIX века – стоят рядом на
                пригорке. Незадолго до назначения молодого священника, уроженца Архангельской
                области, здесь за четыре года сменилось несколько настоятелей. Но тогда еще
                двадцатидвухлетний о. Иоанн Привалов, оставивший исторический факультет
                Архангельского пединститута ради того, чтобы стать иподьяконом епископа
                Пантелеимона (Долганова), а потом священником, пришел в апреле 1993 года в
                сельский храм основательно и надолго. </p>
            

            
            <p>В первый же
                год своего служения молодой священник объявил: «Я крестил 300 человек – и ни
                одного из них больше не увидел в храме. Больше никого не буду крестить без
                серьезной подготовки. Кто придет крестить младенца, тоже должен будет
                готовиться к этому таинству всерьез». Через месяц о. Иоанн Привалов
                познакомился в Москве со священником Георгием Кочетковым и решил использовать
                на приходе разработанную тем систему катехизации. Со временем он согласился с
                мнением о. Георгия о необходимости русификации богослужения на миссионерском
                приходе и начал вводить в службы элементы русского языка. Епископ Архангельский
                и Холмогорский Тихон (Степанов), сторонник церковнославянского богослужения, в
                первые годы своего служения в епархии иногда пенял на это настоятелю
                заостровского храма, но тем не менее с места не снимал, более того, награждал
                за служение и в 2009 году поставил в храм вторым священником члена заостровской
                приходской общины, выпускника Свято-Филаретовского института (ректор института
                – священник Георгий Кочетков) Павла Бибина. </p>
            

            
            <p>За двадцать
                лет оглашение, которое проводили о. Иоанн и его помощники в Архангельске,
                Северодвинске и ближайших деревнях, прошли около пятисот человек. Примерно
                полторы сотни из них стали прихожанами Свято-Сретенского храма с. Заостровье,
                где настоятелем был о. Иоанн, членами трех малых православных братств, входящих
                в Преображенское содружество. Остальные стали прихожанами других храмов
                Архангельской епархии – или других епархий: кто-то уезжал в другие города.
                Большинство остались церковными людьми. </p>
            

            
            <p>Заостровский
                храм стал не только уникальным деревенским приходом, но и одним из центров
                встречи и диалога представителей интеллигенции и Церкви. Встречи с редактором
                «Вестника РХД» Никитой Струве, народным артистом Сергеем Юрским, поэтом Ольгой
                Седаковой, актрисой Еленой Камбуровой и многими другими людьми о. Иоанн и
                братчики организовывали и для Заостровья, и для близлежащих городов –
                Архангельска и Северодвинска. </p>
            

            
            <p>Дружная и
                творческая жизнь прихода оказалась под угрозой после безвременной кончины
                епископа Тихона. Он умел примирять священников, имевших свои, часто очень
                разные, взгляды. За те четырнадцать лет, что он стоял во главе епархии, он
                достиг того, что в епархии, по словам о. Иоанна Привалова, не было показухи, и
                духовенство перестало бояться жизненных трудностей и препятствий в деле
                Господнем. </p>
            

            
            <p>На смену почившему владыке пришел совсем другой человек. В первые же полтора года он «перетасовал» чуть не половину деятельных, ответственных священников епархии. Часто это выглядело не как насильственное перемещение, а как «добровольный» уход в другие епархии тех, кто не выдерживал нового стиля руководства.  <i>Через полгода после прихода нового архиерея уехали секретарь епархии, настоятель храма Всех святых о. Вадим Антипин, настоятель храма Мартина исповедника о. Алексий Дендак, был убран благочинный Северодвинска о. Константин Нецветаев. Настоятель строящегося кафедрального собора о. Роман Ковальский, возглавлявший также храм Ксении Петербургской в Маймаксе, через год уехал из епархии, а все три священника храма были разбросаны по разным местам; настоятель кафедрального Ильинского собора о. Владимир Кузив, духовник епархии, формально сохранил статус настоятеля, но реально потерял всякие полномочия; о. Александр Казарик, настоятель Никольского храма, формально остался на прежнем месте, но реально настоятелем там стал митрополит, к которому &nbsp;в 2011 г. перешло управление финансами и прочими сторонами жизни прихода. Через несколько лет был изгнан из епархии о. Александр Зинин, благочинный, настоятель храмов в г. Новодвинске. Из новодвинского храма были переведены два любимых прихожанами священника, а третий после активных выступлений прихожан с просьбой оставить на приходе хотя бы его через какое-то время был запрещен в служении. Ушел за штат о. Афанасий, настоятель &nbsp;строящегося храма патр. Тихона на Сульфате. &nbsp;</i>  </p>
            

            
            <p>На место
                ушедших священников встали другие люди. Например, родственник казначея епархии
                Серафимы (Голубки) о. Роман Панькив, «прославившийся» тем, что в 2015 году был
                осужден на 7 лет (прокурор просил 18) за развратные действия против ребёнка
                (ученицы воскресной школы).</p>
            

            
            <p>Пришлись
                «ко двору» и остались неколебимы как настоятели архангельских храмов четыре
                человека: о. Евгений Соколов, о. Алексей Денисов, иг. Феодосий (Нестеров) и иг.
                Даниил (Плотников). Почти все они окажутся действующими лицами нашей хроники. </p>
            

            
            <p>«Новые
                веяния» разрушили мирную жизнь многих приходов. Не обошла беда и Заостровье,
                оказавшееся под особенно жестким ударом – и неслучайно. </p>
            

            
            <p>Разница
                между настоятелем Заостровского храма и новым епископом в понимании того, что
                такое Церковь – соборный организм или жесткая «армейская» вертикаль – возникла
                задолго до начала событий. Больше чем за 15 лет до начала нашей хронологической
                таблицы патриарху Алексию II
                было отправлено два письма. </p>
            

            
            <p>«Сегодня,
                как нам думается, нужна всецерковная, открытая для всех пастырей и чад нашей
                Церкви дискуссия по вопросу богослужебного уклада» писали авторы первого обращения. Среди спорных упоминались
                вопросы русификации богослужения,&nbsp; общего
                пения, возвращения к отдельным элементам богослужебной практики Древней церкви
                и Русской церкви прошлых веков. Письмо заканчивалось словами: «На все эти
                вопрошания Церкви надобно ответить соборно, без попытки подавить один голос
                другим... Мы, священнослужители, имеющие разное отношение к поставленной
                проблеме, говорим, что это не мешает нам и пастве нашей быть едиными во Христе
                и во Святой Его Православной Церкви. Мы желаем, чтобы так было всегда». Среди
                35 священнослужителей, подписавших этот призыв к соборному рассуждению, был и
                священник Иоанн Привалов.</p>
            

            
            <p>Под вторым обращением, призывавшим патриарха немедленно
                и без какой бы то ни было дискуссии «во избежание новой церковной смуты пресечь
                губительный и соблазнительный богослужебный модернизм» (так назвали авторы письма
                русификацию богослужения) стояло 42 подписи священнослужителей и 11 подписей
                мирян (преимущественно сотрудников и авторов изданий «Русский вестник», «Русь
                православная», «Радонеж» а также журнала «Москва»). Среди них была и подпись
                архим. Даниила (Доровских) ставшего в 2010 году правящим архиереем
                Архангельской епархии. </p>
            

            
            <hr class="wp-block-separator"/>
            

            
            <p><strong><a href="/zaos1/">Новый епископ «пристреливается»</a></strong></p>
            

            
            <p><a href="/zaos2/">Доносчики и обвинители</a> </p>
            

            
            <p><strong><a href="/zaos3/">Верните нашего брата - о. Павла!</a></strong></p>
            

            
            <p><strong><a href="/zaos4/">Канонада всё явственнее</a></strong></p>
            

            
            <p> <a href="/zaos5/">Захват Заостровья </a></p>
            

            
            <p><strong><a href="/zaos6/">После битвы</a></strong></p>
            


        </div>
    );
};

export default Zaostrov;
